import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import DRSinstanceInput from "../../../components/DRSinstanceInput";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

const CreateDRSInstance = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "DRS Instance",
      route: "/website/loyalty/drs-instance",
    },
    {
      title: "Add DRS Instance",
      route: "/website/loyalty/drs-instance/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"DRS Instance"}>
      <CustomHeaderTitle title={"Create DRS Instance"} />
      <HeaderBread
        navigation={navigation}
        title={"Add DRS Instance"}
      ></HeaderBread>
      <DRSinstanceInput drsinatance={{}} />
    </Layout>
  );
};

export default CreateDRSInstance;
